<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4" v-if="currentType">
          <div class="card-header pt-1 pb-0">
            <div>
              <h3 class="card-title text-primary mb-0">Tipo de Experiencia {{ currentType.name }}</h3>
              <div class="sub-line"></div>
              <div class="row col-12 mt-3">
                <router-link :to="{ name: 'TipoExperiencias' }"
                             class="col-md-2 col-6 col-md-offset-10 btn btn-primary btn-sm text-white bg-blue-600 rounded-lg hover:bg-blue-900 mb-0  ml-auto">
                  Ir al listado
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="card">
              <div class="card-body">
            <div class="row" v-if="currentType">
              <div class="col-md-6">
                <div>
                  <label class="form-control-label">
                    Nombre
                  </label>
                  <p>{{ currentType.name }}</p>
                </div>
                <div class="col-md-6">
                <div>
                  <label class="form-control-label">
                    Descripción
                  </label>
                  <p> {{ currentType.description }}</p>
                </div>
                </div>
                <div>
                  <label class="form-control-label">
                    Imagen
                  </label>
                  <a :href="currentType.imageUrl" target="_blank">
                    <img v-if="currentType.imageUrl" class="img-thumbnail d-block" width="150" :src="currentType.imageUrl">
                  </a>
                </div>
              </div>
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";


     const route = useRoute();
     const store = useStore();

    const getCurrentExperience = async (id) => {
      return await store.dispatch("experienceType/getTypeById", id);
    };

    const currentType = computed(() => store.state.experienceType.currentType);

    onMounted(()=> {
      getCurrentExperience(route.params.id)
    });


</script>
